import { render, staticRenderFns } from "./UsergroupThumbnail.vue?vue&type=template&id=010ae640&"
import script from "./UsergroupThumbnail.vue?vue&type=script&lang=js&"
export * from "./UsergroupThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports